import { SelectControl } from "./SelectControl";
import { DeleteControl } from "./DeleteControl";
import { HistoryControl } from "./HistoryControl";

export const OutlineToolbar = () => {
  return (
    <>
      <SelectControl key="select-control" />
      <DeleteControl key="delete-control" />
      <HistoryControl key="history-control" />
    </>
  );
};
